<script setup lang="ts">
const props = defineProps<{ 
    items: {
        img: string,
        title: string,
        desc: string,
    }[]
}>();
const colorList = [
    'from-primary-100',
    'from-lime-100',
    'from-info-100',
    'from-purple-100',
    'from-teal-100',
    'from-pink-100',
];
</script>

<template>
    <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-16">
        <div
            v-for="_, index in 6"
            :key="index"
            class="relative w-75 h-42.5 bg-linear-to-b to-60% mx-auto border-t border-r border-l overflow-hidden
                border-gray-100 flex justify-center pb-5"
            :class="colorList[index]"
            data-aos="zoom-in" 
            data-aos-duration="1000"
            :data-aos-delay="index % 3 * 300"
        >
            <div class="w-full flex-center pb-12">
                <NuxtImg
                    :src="props.items[index]?.img"
                    class="w-16 aspect-square"
                    loading="lazy"
                    :alt="props.items[index]?.title"
                />
            </div>
            <div 
                class="absolute w-full h-17.5 bottom-0 left-0 backdrop-blur-[2px] bg-linear-to-b from-white/30 to-white
                    flex flex-col items-center text-gray-500 pt-1"
            >
                <span class="text-body1-bold">{{ props.items[index]?.title }}</span>
                <span class="text-body2-semibold">{{ props.items[index]?.desc }}</span>
            </div>
        </div>
    </div>
</template>